module.exports = __webpack_public_path__ + "static/media/leylai.0da26d82.jpeg";